import { createContext, useContext } from "react";

/**
 * Which of the person's WhatsApp numbers the panels below are showing. Every
 * API call passes it on, so groups, lists and activity always belong to the
 * selected number. Undefined = the backend's default (their first number).
 */
export const WaAccountContext = createContext(undefined);

export const useWaAccount = () => useContext(WaAccountContext);
